import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { routeNames } from "../consts/routesNames";
import { useAuth } from "../auth/hooks/usePermissions";
import RequireContactLink from "../components/auth/RequireContactLink";

export default function PrivateRoutes() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={routeNames.LOGIN} replace />;
  }

  return (
    <RequireContactLink>
      <Outlet />
    </RequireContactLink>
  );
}
